import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Const } from "../data/models/const";
import { GetLoginUserResponse } from "../data/models/get-login-user-response";
import { LoginUserApi } from "../api/login-user.api";
import { SessionInfoSingleton } from "../data/singleton/session-info.singleton";
import { AuthService } from "./auth/auth.service";

/**
 * ログイン情報の取得
 */
@Injectable({
  providedIn: "root",
})
export class LoginUserService {
  /**
   * コンストラクタ
   */
  constructor(
    private router: Router,
    private sessionInfoSingleton: SessionInfoSingleton,
    private authService: AuthService,
    private loginUserApi: LoginUserApi
  ) {}

  /**
   * ログインユーザーなどの情報取得
   * - APIをコールし、Constに格納する
   */
  async getLoginUserInfo() {
    try {
      if (this.sessionInfoSingleton.getIdToken() == undefined) {
        await new Promise<any>((resolve, reject) => {
          this.authService.getIdToken().subscribe({
            next: (response: any) => resolve(response),
            error: (err: any) => reject(err),
          });
        });
      }

      const response: GetLoginUserResponse =
        await new Promise<GetLoginUserResponse>((resolve, reject) => {
          this.loginUserApi.getLoginUser().subscribe({
            next: (response: GetLoginUserResponse) => resolve(response),
            error: (err: any) => reject(err),
          });
        });
      Const.loginUser = response.result.login_user;
      Const.site_id = response.result.login_user.sites[0].id;
      Const.mjitUser = Number(response.result.login_user.user_type) === 0;
      Const.adminUser = Number(response.result.login_user.user_type) === 1;
      console.log("ユーザー情報取得");
    } catch (error) {
      console.error(error);

      // トークンが取得できていればログアウト、できていなければ遷移
      if (this.sessionInfoSingleton.getIdToken() == undefined) {
        this.authService.signOut();
      } else {
        this.router.navigate(["/login"]);
      }
    }
  }
}
